import React from "react";
import { useForm, useFormContext } from "react-hook-form";
import InputField from "../../../common/components/FormFields/InputField";
import { useEMRContext } from "./EMRContextGync";
import InputArea from "../../../common/components/FormFields/InputArea";

export default function GynacExaminations(props) {
  const { ancChecked, setAncChecked } = useEMRContext();
  const defaultValues = {
    DM: "",
  };
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    defaultValues,
  });
  let anc = watch("anc");
  return (
    <div>
      <div className="flex justify-between bg-[#FEDBE8] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-1">Systemic Examinations</p>
      </div>
      <div className=" border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        {anc === false || anc === undefined ? (
          <div className="grid grid-cols-4  gap-2 p-2 border  h-64 whitespace-normal overflow-auto">
            <div className="w-full mb-2">
              <InputArea control={control} name="cvs" label="CVS" />
            </div>
            <div className="w-full mb-2">
              <InputArea control={control} name="cns" label="CNS" />
            </div>
            <div>
              <InputArea
                control={control}
                name="pa"
                label="P/A"
                disabled={props.pastData !== null}
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="ps"
                label="P/S"
                disabled={props.pastData !== null}
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="pv"
                label="P/V"
                disabled={props.pastData !== null}
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="rs"
                label="R/S"
                disabled={props.pastData !== null}
              />
            </div>

            <div>
              <InputArea
                control={control}
                name="systemlocalExamination"
                label="Local Examination"
                disabled={props.pastData !== null}
              />
            </div>

            <div className="w-full mb-2">
              <InputArea
                control={control}
                name="perRectalexam"
                label="Per Rectal Examination"
              />
            </div>
            <div className="w-full mb-2">
              <InputArea
                control={control}
                name="onExamination"
                label="On Examination"
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="leftSideBreastExmination"
                label="Left Side Breast Examination"
                disabled={props.pastData !== null}
              />
            </div>

            <div>
              <InputArea
                control={control}
                name="rightSideBreastExmination"
                label="Right Side Breast Examination"
                disabled={props.pastData !== null}
              />
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-2 p-2 border  h-60 whitespace-normal overflow-auto">
            <div>
              <InputArea
                control={control}
                name="cvs"
                label="CVS"
                disabled={props.pastData !== null}
              />
            </div>
            <div className="w-full mb-2">
              <InputArea control={control} name="cns" label="CNS" />
            </div>
            <div>
              <InputField control={control} name="pa" label="PA" />
            </div>
            <div>
              <InputField control={control} name="fhs" label="FHS(min)" />
            </div>
            <div>
              <InputArea
                control={control}
                name="ps"
                label="P/S"
                disabled={props.pastData !== null}
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="pv"
                label="P/V"
                disabled={props.pastData !== null}
              />
            </div>
            <div>
              <InputArea
                control={control}
                name="rs"
                label="R/S"
                disabled={props.pastData !== null}
              />
            </div>

            <div className="w-full mb-2">
              <InputArea
                control={control}
                name="systemlocalExamination"
                label="Local Examination"
              />
            </div>
            <div className="w-full mb-2">
              <InputArea
                control={control}
                name="perRectalexam"
                label="Per Rectal Examination"
              />
            </div>
            <div className="w-full mb-2">
              <InputArea
                control={control}
                name="onExamination"
                label="On Examination"
              />
            </div>
            <div>
              <InputField control={control} name="fs" label="FS(cm)" />
            </div>

            <div>
              <InputField control={control} name="pr" label="PR" />
            </div>

            <div>
              <InputField control={control} name="speculum" label="Speculum" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

